export const AdditionalInformationFormName = 'additional-information';

export enum AdditionalInformationFormFields {
  Notes = 'notes',
}
